export const DEFAULT_SIDE_PANEL_WIDTH = 30;
export const DEFAULT_FIND_DROP_WIDTH = 25;
